import _ from 'underscore';
import pageContext from '@bingads-webui-static-legacy/page-context';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';

const CAMPAIGN_PAGE_SIZE = 10;
const ADGROUP_PAGE_SIZE = 6;

function transformCampaignData(data) {
  if (!data || !_.isArray(data)) {
    return [];
  }

  const campaignData = data.map((item) => {
    return {
      Id: item.Id,
      name: item.Name,
      status: item.Status,
    };
  });

  return {
    totalCount: data.totalCount,
    items: campaignData,
  };
}

function transformAdgroupData(data) {
  if (!data || !_.isArray(data)) {
    return [];
  }

  const adgroupData = data.map((item) => {
    return {
      Id: item.Id,
      name: item.Name,
      status: item.Status,
      campaignId: item.Campaign.Id,
      campaignName: item.Campaign.Name,
    };
  });

  return {
    totalCount: data.totalCount,
    items: adgroupData,
  };
}

export function getCampaignData(queryText = '', pageNumber = 0, pageSize = CAMPAIGN_PAGE_SIZE, customFilter = '') {

  const query = {
    $select: 'Id, Name, Status',
    $skip: pageNumber * pageSize,
    $top: pageSize,
    $filter: `contains(Name, '${queryText}') and (CampaignType ne Enum.CampaignType'Smart')`,
  };

  if (customFilter) {
    query.$filter += ` and ${customFilter}`;
  }

  return jsdata.Campaign.findAll({
    query,
  }).then((data) => {
    return transformCampaignData(data);
  });
}

export function getAdgroupData(queryText = '', pageNumber = 0, pageSize = ADGROUP_PAGE_SIZE, scopeParentItem, customFilter = '') {
  const $select = _.compact([
    'Id',
    'Name',
    'Status',
    pageContext.Permissions.IsPersonalizedOffersEnabled && 'AdGroupCashback',
  ]).join(', ');

  const query = {
    $expand: 'Campaign($select=Id,Name,CampaignType)',
    $select,
    $skip: pageNumber * pageSize,
    $top: pageSize,
    $count: true,
    $filter: `contains(Name, '${queryText}')`,
  };

  if (customFilter) {
    query.$filter += ` and ${customFilter}`;
  }

  if (scopeParentItem) {
    if (scopeParentItem.AccountId) {
      // MCC user only has currentCustomer
      query.entitySet =
        edmCampaign
          .currentCustomer
          .Accounts
          .$withKey(Number(scopeParentItem.AccountId))
          .Campaigns.$withKey(Number(scopeParentItem.Id))
          .AdGroups.toJSON();
    } else {
      query.entitySet =
        edmCampaign
          .currentAccount
          .Campaigns
          .$withKey(Number(scopeParentItem.Id))
          .AdGroups.toJSON();
    }
  }

  return jsdata.AdGroup.findAll({
    query,
  }).then((data) => {
    return transformAdgroupData(data);
  });

}

